import { ReactSVG } from "react-svg";

import "./styles.scss";

const CustomInput = ({ icon, ...rest }) => {
  return (
    <div className="custom-input">
      <input {...rest} />
      {icon && <ReactSVG src={icon} className="custom-input-icon" />}
    </div>
  );
};

export default CustomInput;
